import { useSelector } from 'react-redux';
import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { ApplicationState, WithGuideLink, WithOwnerId } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { RouteName, ActionType, TextKey } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';
import { getEnterpriseName } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';
import { Breadcrumbs } from '../../components/BreadcrumbList';
import { HeadingAction } from '../../legacy/React/Components/HeadingAction/Action/types';
import { TextMessagingContentContainer } from './components/TextMessagingContent/TextMessagingContentContainer';

export const GuestExperienceTextMessagingContainer = ({
    guideLink,
    ownerId: enterpriseId,
}: WithGuideLink & WithOwnerId) => {
    const enterpriseName: string = useSelector((state: ApplicationState) => getEnterpriseName(state, { enterpriseId }));

    const resolveRoute = useResolveRoute();
    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });

    const actions: HeadingAction[] = [
        {
            url: guideLink,
            target: '_blank',
            icon: IconName.Help,
            text: <LocalizedText textKey={TextKey.Help} />,
            type: ActionType.Link,
        },
    ];

    const breadcrumbs: Breadcrumbs = [
        { text: enterpriseName, url: enterpriseUrl },
        {
            text: <LocalizedText textKey={TextKey.TextMessaging} />,
            active: true,
        },
    ];

    return (
        <ModalWrapper>
            <ModalHeader actions={actions} breadcrumbs={breadcrumbs} />
            <NewModalBodyWrapper padded>
                <TextMessagingContentContainer enterpriseId={enterpriseId} />
            </NewModalBodyWrapper>
        </ModalWrapper>
    );
};
